import {Intervals} from "../../Intervals"

/**
 * Alarm Resolution Report settings schema.
 *
 * Like Detailed Alarm, the report has no per-run configuration beyond the
 * delivery schedule: the pre-schema AlarmResolutionReportSettings.vue rendered
 * only the interval and (when weekly) the day to send, both wrapped in
 * `v-if="isSavable"`. Those map onto the shared template-only Scheduled Delivery
 * section. Setting keys are unchanged, so saved templates are unaffected.
 */
export default {
    slug: 'alarm-resolution-report',
    icon:
        '<path stroke="none" d="M0 0h24v24H0z" fill="none"/>'
        + '<path d="M9.615 20h-2.615a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8" />'
        + '<path d="M14 19l2 2l4 -4" />'
        + '<path d="M9 8h4" />'
        + '<path d="M9 12h2" />',
    permission: 'manage_alarm_resolution_report',
    title: 'Alarm Resolution',
    description: 'Every alarm and what was done about it, including who responded and how quickly.',
    info: 'Compares how each group handled alarms that started in the period: how many were resolved, snoozed or still active, average time to resolve, and response time (start to first comment, snooze or resolve), including the share within 2 hours.',

    sections: [
        {
            // Template-only: the recurring send schedule. On-demand runs pick an
            // explicit start/end on the run form, so this section is hidden there
            // (matches Detailed Alarm / Excursion).
            title: 'Scheduled Delivery',
            description: 'Automatically send this report on a recurring schedule.',
            showIf: ({isSavable}) => isSavable === true,
            fields: [
                {
                    key: 'interval',
                    type: 'select',
                    label: 'Send frequency',
                    description: 'How often the report is emailed, around 1 AM site time. Both daily options cover the previous day, weekly the 7 days before, semi-monthly each half month, and monthly the previous month.',
                    options: Intervals.INTERVAL_OPTIONS,
                    fromContext: true,
                },
                {
                    key: 'weekday',
                    type: 'select',
                    label: 'Day to receive report',
                    description: 'The day the weekly report is emailed, around 1 AM site time. It covers the 7 days ending the day before.',
                    options: Intervals.WEEKDAY_OPTIONS,
                    showIf: ({interval}) => interval === Intervals.WEEKLY,
                },
            ],
        },
    ],
}
